module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 艺术节")])], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "elalert",
    attrs: {
      "title": "温馨提示",
      "type": "error"
    }
  }, [_vm._v("\n            1.请先登陆单位会员帐号或注册（注意只对机构单位会员，个人会员无法报名）"), _c('br'), _vm._v("\n            2.请您确保在整个申报流程中，您所填写的信息属实。"), _c('br')]), _vm._v(" "), _c('el-collapse', {
    staticClass: "elcollapse",
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.groupList), function(group, index) {
    return _c('el-collapse-item', {
      key: index,
      attrs: {
        "title": group.name,
        "name": index
      }
    }, [_c('div', {
      staticClass: "elcollapse_group_desc"
    }, [_vm._v(_vm._s(group.desc))]), _vm._v(" "), _c('div', _vm._l((group.list), function(item, vindex) {
      return _c('div', {
        key: vindex,
        staticClass: "apply_and_name"
      }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
        staticClass: "apply_but"
      }, [_c('el-button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.goApply(item)
          }
        }
      }, [_vm._v("立即报名")]), _vm._v(" "), _c('el-button', {
        on: {
          "click": function($event) {
            return _vm.showDetail(item)
          }
        }
      }, [_vm._v("申报须知")])], 1)])
    }), 0)])
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "申报须知",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "html-data",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goApply(_vm.detail)
      }
    }
  }, [_vm._v("立即报名")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15fc5ed6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/yishujie/YishujieApplyIndex.vue
// module id = 1155
// module chunks = 0